import Swiper from 'swiper/bundle';

// 詳細リンク用swiper
const charmSectionLinkSwiperElms = document.querySelectorAll("[data-role='charm-section-link-swiper']");
if (charmSectionLinkSwiperElms.length) {
  charmSectionLinkSwiperElms.forEach((elm) => {
    const totalItems = elm.querySelectorAll('.swiper-slide').length;
    const pagerCurrent = elm.querySelector('[data-role="charm-section-link-nav-pager-current"]');
    const pagerTotal = elm.querySelector('[data-role="charm-section-link-nav-pager-total"]');
    if (pagerTotal) pagerTotal.textContent = totalItems;
    let charmSectionLinkSwiper = new Swiper(elm.querySelector('.swiper'), { // eslint-disable-line no-unused-vars
      slidesPerView: 1.5,
      spaceBetween: 16,
      loop: true,
      centeredSlides: true,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      speed: 1500,
      breakpoints: {
        1012: {
          slidesPerView: 3,
          spaceBetween: 24,
          centeredSlides: false,
        },
      },
      navigation: {
        nextEl: elm.querySelector('[data-role="charm-section-link-nav-next"]'),
        prevEl: elm.querySelector('[data-role="charm-section-link-nav-prev"]'),
      },
      pagination: {
        el: elm.querySelector('[data-role="charm-section-link-pagination"]'),
        clickable: true,
      },
      on: {
        slideChange: function () {
          pagerCurrent.textContent = this.realIndex + 1;
        },
      },
    });
  });
}
